import { styled } from "styled-components";
import { theme } from "../../../styles/Theme";

const Skills = styled.section`
    position:relative;
`


const Skill = styled.div`
    width: 330px;
    flex-grow: 1;
    padding: 53px 20px 40px;

    @media ${theme.media.mobile} {
        padding: 62px 0 40px;

    }
`
export const IconWrapeer1 = styled.div`
    position: relative;

    &::before {
        content: "";
        display: inline-block;
        width: 80px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.1);
        transform: rotate(45deg) translate(-50%, -50%);/* чтобы не перезаписать transform, в него через пробел можно добавлять еще свойства. */
        position: absolute;
        left: 50%;
        top: 50%;
        transform-origin: top left;
    }
`

const SkillTitle = styled.h3`
    color: #e9f5ff;
    text-align: center;
    margin: 70px 0 15px;
    text-transform: uppercase;
`

const SkillText = styled.p`
    color: #ffffffdf;
    padding: 10px;
    text-align: center;
`

export const S = {
    Skills,
    Skill,
    IconWrapeer1,
    SkillTitle,
    SkillText
}